// extracted by mini-css-extract-plugin
export default {"footer":"N9wZe5","top":"vI3rJr","bottom":"X87Z5S"};